export type SwipeTransitionFunction = 'linear' | 'ease' | 'ease-in';

export enum SwipeState {
  MOVING,
  NONE,
}
